import React, { useState, useEffect } from 'react';
import * as apiClient from "../../common/apiClient";

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import CircularProgress from '@material-ui/core/CircularProgress';

import Button from '@material-ui/core/Button';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { Autocomplete } from '@material-ui/lab';
import exportFromJSON from 'export-from-json';
import moment from "moment";
import "./report.css";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export const AttedanceSummaryReport = (props: any) => {
  const classes = useStyles({});
  const [cols, setCols] = useState<string[]>([]);
  const [data, setData] = useState([]);
  const [fectched, setFectched] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [rptType, setRptType] = useState("attendance");

  const [employees, setemployees] = useState<any>([]);
  const [selectedEmployees, setSelectedEmployees] = useState<any[]>([]);

  const getEmployees = () => {
    apiClient
      .getdataWithOrder("employees", "name", "ASC")
      .then((res) => {
        setemployees(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateReport = () => {
    setFectched(false);
    let sDate = moment(startdate).format("YYYY-MM-DD");
    let eDate = moment(enddate).format("YYYY-MM-DD");

    if (startdate === "") {
      sDate = "";
    }
    if (enddate === "") {
      eDate = "";
    }



    let employeeId = selectedEmployees.length > 0 ? selectedEmployees.map((h: any) => h.id).join(',') : "0";

    let data = {
      fromDate: sDate,
      toDate: eDate,
      employeeId, // Include the list of selected employee IDs
    };

    setLoading(true);
    let apimethod = "/report/attendancereport";
    if (rptType === "attendancesummary") {
      apimethod = "/report/attendancesummaryreport";
    }

    apiClient
      .loadReport(apimethod, data)
      .then((res) => {
        console.log(res);
        setData(res);
        setFectched(true);
        if (res.length > 0) {
          let keys = Object.keys(res[0]);
          setCols(keys);
        }
        setLoading(false);
        if(res && res.length>0)
                    {
                        const fileName = 'download';
                        const exportType = 'xls';
                        exportFromJSON({data:res, fileName, exportType })
        
                    }
                    else
                    {
                        alert("No record found");
                    }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getEmployees();
  }, []);

  return (
    <div>
      <div className="report-heading">{props.rptTtile}</div>

      <div className="filters">
        <div className="filters-input">
          <div className="start-date">
            Start Date:{" "}
            <input
              type="date"
              value={startdate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />
          </div>
          <div className="end-date">
            End Date:{" "}
            <input
              type="date"
              value={enddate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
            />
          </div>
          <div className="end-date">
            Report Type:{" "}
            <select
              style={{ height: "34px" }}
              onChange={(e) => {
                setRptType(e.target.value);
              }}
            >
              <option value="attendance" selected={rptType === "attendance"}>
                Attendance Report
              </option>
              <option
                value="attendancesummary"
                selected={rptType === "attendancesummary"}
              >
                Attendance Summary Report
              </option>
            </select>
          </div>
        </div>

        <div style={{ textAlign: "left", marginLeft: "70px",width:700 }}>
          <Autocomplete
            multiple
            options={employees}
            getOptionLabel={(option: any) => option.name}
            value={selectedEmployees}
            onChange={(event, newValue) => setSelectedEmployees(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Select Employees"
                placeholder="Choose employees"
                size="small"
              />
            )}
          />
        </div>

        {fectched && data.length > 0 && (
          <div>Total {data.length} Records found</div>
        )}
        {fectched && data.length === 0 && <div>No Record found</div>}
      </div>

      <div className="filter-action">
        <Button
          variant="contained"
          onClick={generateReport}
          startIcon={<AssessmentIcon />}
          color="primary"
        >
          Generate Report
        </Button>
      </div>

      <div className="report-data">
        {isLoading && <CircularProgress />}
        <div className="w3-responsive"></div>
      </div>
    </div>
  );
};
